import { render, staticRenderFns } from "./PlayerAvatar.vue?vue&type=template&id=5651bd26&scoped=true&"
import script from "./PlayerAvatar.vue?vue&type=script&lang=js&"
export * from "./PlayerAvatar.vue?vue&type=script&lang=js&"
import style0 from "./PlayerAvatar.vue?vue&type=style&index=0&id=5651bd26&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5651bd26",
  null
  
)

export default component.exports